import { render, staticRenderFns } from "./GroupsQueryList.vue?vue&type=template&id=41fc9a40&scoped=true&"
import script from "./GroupsQueryList.vue?vue&type=script&lang=js&"
export * from "./GroupsQueryList.vue?vue&type=script&lang=js&"
import style0 from "./GroupsQueryList.vue?vue&type=style&index=0&id=41fc9a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc9a40",
  null
  
)

export default component.exports